import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import withLoader from 'components/organisms/withLoader';
import { scrollToErrorIfExist, showResult } from 'utils';
import Button from 'components/atoms/button';
import { Formik, Form } from 'formik';
import { Card, CardBody, Table } from 'reactstrap';
import forms from 'constants/forms';
import validationSchema from 'components/organisms/adminPanels/agencies/validationSchema';
import requestBodyGenerator from 'components/organisms/adminPanels/agencies/requestBodyGenerator';
import Contact from 'components/organisms/adminPanels/agencies/components/contact';
import Address from 'components/organisms/adminPanels/agencies/components/address';
import IRS from 'components/organisms/adminPanels/agencies/components/irs';
import Registration from 'components/organisms/adminPanels/agencies/components/registration';

const AddAgency = () => {
  const formRegistration = [...forms.adminPanelsAgency.agencyAdd.registration];
  const history = useHistory();
  const {
    adminPanelAgencies: { createAgency },
  } = useDispatch();
  const { agency } = useSelector((state) => state.adminPanelAgencies);
  const initialValues = { ...agency };

  const { getAgency: agencyDetailsLoading, createAgency: submitLoading } =
    useSelector((state) => state.loading.effects.adminPanelAgencies);

  const submitHandler = async (agencyRequest) => {
    const body = requestBodyGenerator(agencyRequest);
    const { data, error } = await createAgency(body);
    if (error) return showResult(error);
    if (data) {
      showResult();
      history.push(`/admin/agency/${data.guid}`);
    }
  };
  return (
    <div className="admin-patient">
      {withLoader(
        agencyDetailsLoading,
        <>
          {agency && (
            <Card className="card-border">
              <CardBody>
                <div className="admin-patient-header">
                  <span>Add Agency</span>
                </div>
                <Formik
                  onSubmit={submitHandler}
                  initialValues={initialValues}
                  validationSchema={validationSchema()}
                >
                  {({ errors }) => (
                    <Form>
                      <div className="admin-patient-edit-form">
                        <Table>
                          <tbody>
                            <tr>
                              <td>
                                <Contact errors={errors} />
                              </td>
                              <td>
                                <Address errors={errors} />
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <Registration
                                  formRegistration={formRegistration}
                                  errors={errors}
                                />
                              </td>
                              <td>
                                <IRS errors={errors} />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                      <div className="text-center">
                        <Button
                          disabled={submitLoading && errors}
                          type="submit"
                          text="Save"
                          handleClick={scrollToErrorIfExist}
                        />
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          )}
        </>,
      )}
    </div>
  );
};

export default AddAgency;
